membershipApp.controller('RequestController', ['$scope', '$http', '$timeout', '$translate', '$filter', function ($scope, $http, $timeout, $translate, $filter) {
	var $translateThis = $filter('translate');
	var today = new Date();
	var requestStartYear = new Date("2024-01-01");
	requestStartYear.setHours(0,0,0,0);
	today.setHours(0,0,0,0);
	var dd = today.getDate();
	var mm = today.getMonth() + 1;
	var nextYear = today.getFullYear() + 1;
	var todayPlusOneYear = new Date(mm + '/' + dd + '/' + nextYear);
	$scope.createNewRequestView = false;

	if(localStorage.getItem('userModel')){
		
		let modelStorage = localStorage.getItem('userModel');
		$scope.Model =  JSON.parse(modelStorage);
		if($scope.Client == null)
			$scope.Client =  $scope.Model.Client;
	}

	// public ActionResult GetFreezeRequestByClientId(int ClientID, DateTime DateStart, DateTime DateEnd, string Namespace, int GymID)

	$scope.getReport = function () {
		var dataObject = {
			ClientID: $scope.Client.ClientID,
			CardID: $scope.Client.CardID,
			Email: $scope.Client.Email,
			DateStart: today.toISOString(),
			DateEnd: todayPlusOneYear.toISOString(),
			Namespace: namespace,
			GymId: gymid,
		}

		$http({
			method: 'POST',
			url: '/account/GetReport',
			data: dataObject
		}).success(function (data) {
			$scope.Services  = [...new Map(data.Services.map(v => [v.ServiceDefinitionID, v])).values()]
			$scope.FutureServices = _.groupBy(data.FutureServices, mem => mem.ServiceDefinitionID);
		}).error(function () {
		});
	}

	$scope.getReport();


	$scope.getRequest = function () {

			var dataObject = {
				GymID: gymid,
				Namespace: namespace,
				ClientID: $scope.Client.ClientID,
				DateStart: requestStartYear.toISOString(),
				DateEnd: todayPlusOneYear.toISOString()
			}

			$http({
				method: 'POST',
				url: '/Membership/GetFreezeRequestByClientId/',
				data: dataObject
			}).success(function (data) {
				$scope.requestList = data;

				
			}).error(function () {
				// console.log('error');
			});
	}

	$scope.getRequest();

	$scope.clickMore = function(item){
		if(item.showMore){
			item.showMore = false
		}else{
			item.showMore = true;
		}
	}

	$scope.showCreateNewRequest = function(){
		$scope.createNewRequestView = true;
	}

	$scope.hideCreateNewRequest = function(){
		$scope.createNewRequestView = false;
	}

	$scope.changeServiceModel = function(){
		cleanRequetedFields();
		$scope.requestMembershipModel =  JSON.parse($scope.requestMembership);
		getFutureMemberships($scope.requestMembershipModel);
	}

	function cleanRequetedFields(cleanAll = false){
		$scope.requestMembership = cleanAll ? undefined : $scope.requestMembership;
		$scope.currentFutureMemberships = undefined;
		$scope.requestType = null;
		$scope.requestStartDate = null;
		$scope.requestDuration = 1;
		$scope.requestMessage = '';
	}

	$scope.changeServiceDateModel = function(){
		if($scope.requestStartDate){
			$scope.requestMembershipStartDate =  JSON.parse($scope.requestStartDate);
		}
	}

	function getFutureMemberships(el){
		$scope.currentFutureMemberships = $scope.FutureServices[el.ServiceDefinitionID];
	}


	// public bool AddFreezeRequest(int ClientID, int CardID, int ServiceID, int RecurringID, int Duration, int Type, string Message, string Namespace, int GymID)
	// int Type - 0: Membership Freeze, 1: Membership Unfreeze, 2: Membership Cancel, 3: Other
	$scope.requestDuration = 1;

	$scope.duratonPlus = function(){
		if(gym[0].CustomersPortalMaxFreezeMonths > 0 && $scope.requestDuration == gym[0].CustomersPortalMaxFreezeMonths){
			
		}else{
			$scope.requestDuration += 1;
		}
	}

	$scope.duratonMinus = function(){
		if($scope.requestDuration > 1){
			$scope.requestDuration -= 1;
		}
	}

	$scope.createRequest = function () {

		if(!$scope.loading){
			$scope.loading = true;

			if((!$scope.requestMembershipModel.Recurring && $scope.requestMembershipModel.Payment == 0) || $scope.requestMembershipModel.RecurringId <= 0){
				paymentServiceType= 2;
			}else if($scope.requestMembershipModel.Recurring && $scope.requestMembershipModel.Payment == 1){
				paymentServiceType= 1;
			}else{
				paymentServiceType= 0;
			}

			var dataObject = {
				GymID: gymid,
				Namespace: namespace,
				Message: $scope.requestMessage,
				Type: $scope.requestType,
				Duration: $scope.requestDuration,
				RecurringID: $scope.requestMembershipModel.RecurringID,
				ServiceID: $scope.requestMembershipModel.ServiceID,
				CardID: $scope.Client.CardID,
				ClientID: $scope.Client.ClientID,
				PaymentServiceType: paymentServiceType
			}

			if($scope.requestMembershipStartDate){
				dataObject.StartFreezeDate = $scope.requestMembershipStartDate.DateStart;
				dataObject.ServiceID = $scope.requestMembershipStartDate.ServiceID;
			}
			
	
			$http({
				method: 'POST',
				url: '/Membership/AddFreezeRequest/',
				data: dataObject
			}).success(function (data) {

				if( data == 'True' ){
					var translated = $translateThis('Request is successful.');

					Swal.fire({
						type: 'success',
						title: translated,
						onAfterClose: (function () {
							cleanRequetedFields(true);
							$scope.getRequest();
							$timeout(function() {
								$scope.createNewRequestView = false;
								$scope.loading = false;
							});
						})
					})
				}else{
					var translated = $translateThis(data);

					Swal.fire({
						type: 'warning',
						title: translated,
						onAfterClose: (function () {
							$timeout(function() {
								$scope.loading = false;
							});
						})
					})
				}
	
			}).error(function () {
				var translated = $translateThis('error');

					Swal.fire({
						type: 'warning',
						title: translated,
						onAfterClose: (function () {
							$timeout(function() {
								$scope.loading = false;
							});
						})
					})
				// console.log('error');
			});
		}
}
	
}]);